module.exports = __webpack_public_path__ + "img/专场券.f5efa9fc.png";